/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformKeyValues extends models.KeyValues {
    getFixupPrototypeFunction() { return PlatformKeyValues.fixupPrototype; }

    static newInstance(model: Partial<PlatformKeyValues>): PlatformKeyValues {
        let obj = Object.assign(new PlatformKeyValues(), model);
        PlatformKeyValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformKeyValues>): PlatformKeyValues {
        if (!model) return null;
        return PlatformKeyValues.newInstance(<PlatformKeyValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformKeyValues) {
        if (!obj) return;

        models.PlatformKeyValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformKeyValues): boolean {
        if (models.KeyValues.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PlatformKeyValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of the platform kind (e.g. namespace, deployment, node)
     */
    kind: string;

}
